const NAME_LIMIT = 255;
const MIN_ACTIVITY_DAYS = 1;

const toNumber = value => {
  if (value === '' || value === null || value === undefined) return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const toUnixMillis = value => {
  if (value === '' || value === null || value === undefined) return null;
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value < 1e12 ? value * 1000 : value;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const numeric = Number(trimmed);
    if (Number.isFinite(numeric))
      return numeric < 1e12 ? numeric * 1000 : numeric;
    const parsed = Date.parse(trimmed);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return null;
};

const isInteger = value => Number.isInteger(value);

export const validationErrors = (values = {}, serviceGroups = []) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Name is required.';
  } else if (values.name.length > NAME_LIMIT) {
    errors.name = `Name must be ${NAME_LIMIT} characters or less.`;
  }

  if (values.activityMode === 'days') {
    const days = toNumber(values.daysFromToday);
    if (days === null || !isInteger(days) || days < MIN_ACTIVITY_DAYS) {
      errors.daysFromToday = 'Activity days must be a positive integer.';
    }
  } else {
    const dateFrom = toUnixMillis(values.dateFrom);
    const dateTo = toUnixMillis(values.dateTo);
    if (dateFrom === null && dateTo === null) {
      errors.dateFrom = 'Activity period is required.';
    }
    if (values.dateFrom && dateFrom === null) {
      errors.dateFrom = 'Activity date from is invalid.';
    }
    if (values.dateTo && dateTo === null) {
      errors.dateTo = 'Activity date to is invalid.';
    }
    if (dateFrom !== null && dateTo !== null && dateFrom > dateTo) {
      errors.dateFrom = 'Activity date range is invalid.';
      errors.dateTo = 'Activity date range is invalid.';
    }
  }

  const topUpFrom = toNumber(values.virtualTopUpFrom);
  if (values.virtualTopUpFrom && topUpFrom === null) {
    errors.virtualTopUpFrom = 'Virtual top up from must be a valid number.';
  }

  const topUpTo = toNumber(values.virtualTopUpTo);
  if (values.virtualTopUpTo && topUpTo === null) {
    errors.virtualTopUpTo = 'Virtual top up to must be a valid number.';
  }

  if (serviceGroups.length) {
    const groupErrors = serviceGroups.map(group => ({
      rows: (group?.rows || []).map(() => ({})),
    }));
    let hasServiceError = false;

    serviceGroups.forEach((group, groupIndex) => {
      const rows = group?.rows || [];
      rows.forEach((row, rowIndex) => {
        const serviceType = toNumber(row.serviceType);
        const useCount = toNumber(row.useCount);
        const sumFrom = toNumber(row.sumFrom);
        const sumTo = toNumber(row.sumTo);
        const hasAnyValue =
          serviceType !== null ||
          useCount !== null ||
          sumFrom !== null ||
          sumTo !== null;

        if (!hasAnyValue) return;

        if (serviceType === null || !isInteger(serviceType)) {
          groupErrors[groupIndex].rows[rowIndex].serviceType =
            'Service type is required.';
          hasServiceError = true;
        }

        if (row.useCount && useCount === null) {
          groupErrors[groupIndex].rows[rowIndex].useCount =
            'Use count must be a valid number.';
          hasServiceError = true;
        }

        if (row.sumFrom && sumFrom === null) {
          groupErrors[groupIndex].rows[rowIndex].sumFrom =
            'Sum from must be a valid number.';
          hasServiceError = true;
        }

        if (row.sumTo && sumTo === null) {
          groupErrors[groupIndex].rows[rowIndex].sumTo =
            'Sum to must be a valid number.';
          hasServiceError = true;
        }

        if (sumFrom !== null && sumTo !== null && sumFrom > sumTo) {
          groupErrors[groupIndex].rows[rowIndex].sumTo =
            'Sum from must be less than sum to.';
          hasServiceError = true;
        }
      });
    });

    if (hasServiceError) {
      errors.serviceGroups = groupErrors;
    }
  }

  return errors;
};
